// extracted by mini-css-extract-plugin
export default {"providerFooter":"Dy2l5","moreTripLink":"KZHuQ","moreTripLink_text":"bMT57","moreTripLink_icon":"iPMM6"};